import { render, staticRenderFns } from "./ConfirmDel.vue?vue&type=template&id=201bb7aa&scoped=true"
import script from "./ConfirmDel.vue?vue&type=script&lang=js"
export * from "./ConfirmDel.vue?vue&type=script&lang=js"
import style0 from "./ConfirmDel.vue?vue&type=style&index=0&id=201bb7aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "201bb7aa",
  null
  
)

export default component.exports